import GridKeikkaEditor_SourceAsiakasSettings from "./GridKeikkaEditor_SourceAsiakasSettings";
import MyDialog from "src/components/MyDialog/MyDialog";
import PropTypes from "prop-types";

export default function GridKeikkaEditor_SourceAsiakasSettingsModal({ isOpen, onClose }) {
  return (
    <MyDialog
      title="Lähdeasiakas-asetukset"
      open={isOpen}
      onClose={onClose}
      dialogProps={{ maxWidth: "xl" }}>
      <GridKeikkaEditor_SourceAsiakasSettings onClose={onClose} />
    </MyDialog>
  );
}

GridKeikkaEditor_SourceAsiakasSettingsModal.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
};
